import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'messages'
const verb = 'put'

export default class OspreyMessagesUpdate extends BaseAction {
    constructor(dataKey, onError) {
        const id = 'fa50fa0d-f836-4a4e-aabc-070cf254118e'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true

        this.onError = onError
    }

    update(id, message, contextOrn) {
        if (!message) {
            throw new Error('Missing message object')
        }

        this.path = `/${resource}/${id.value}?X-Context-Orn=${contextOrn}`

        this.params = {
            message
        }

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/messages/messages-update.js